import { render } from "./BlogView.vue?vue&type=template&id=121f3ec2&scoped=true"
import script from "./BlogView.vue?vue&type=script&lang=js"
export * from "./BlogView.vue?vue&type=script&lang=js"

import "./BlogView.vue?vue&type=style&index=0&id=121f3ec2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-121f3ec2"]])

export default __exports__